var ContentTypes;
(function (ContentTypes) {
    ContentTypes["PageCopy"] = "pageCopy";
    ContentTypes["TextCopy"] = "textCopy";
    ContentTypes["ComponentBlock"] = "componentBlock";
    ContentTypes["Media"] = "media";
})(ContentTypes || (ContentTypes = {}));

export { ContentTypes };
//# sourceMappingURL=ContentfulComponentBlock.types.esm.js.map
